var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-breadcrumb',{attrs:{"separator":" "}},_vm._l((_vm.items),function(item,idx){return _c('a-breadcrumb-item',{key:idx},[_c('router-link',{attrs:{"to":{name: item.route}}},[_vm._v(_vm._s(item.name))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }